import React from 'react';
import useMediaQuery from "../hooks/useMediaQuery";

const ProductRangeLayout = ({ product }) => {
    const isDesktop = useMediaQuery('(min-width:1280px)');
    return (
        <>
            <section>
                <div className='relative' style={{ minHeight: !isDesktop ? '70vh': 'auto', height: !isDesktop ? '90vh': 'auto'}}>
                    <img style={{ minHeight: !isDesktop ? '70vh': 'auto',  height: !isDesktop ? '90vh': 'auto'}}
                        className="h-full object-cover w-full lg:block hidden"
                        src={product.range.imageUrl}
                        alt=""
                    />
                    <img 
                        className="h-full portrait:hidden object-fit w-full lg:hidden block"
                        src={product.range.imageUrl}
                        alt=""
                    /> 
                    <img 
                        className="h-full landscape:hidden object-fit w-full lg:hidden block"
                        src={product.range.smImageUrl}
                        alt=""
                    /> 
                    <div className='absolute top-4 lg:top-8'>
                        <div className='ml-4 lg:ml-16'>
                            <h2 className='lg:mr-12' style={{ color: product.range.color.label }} >{product.range.label}</h2>
                            <p className='mt-2 lg:mt-6 lg:font-bold lg:w-3/4 px-1' style={{ color: product.range.color.description }}>
                                {product.range.description}
                            </p>
                        </div>

                        {
                            product.name === 'Milk' &&
                            <div className='flex flex-col m-4 lg:my-8 w-0 lg:ml-16'>
                                <div style={{background: product.range.color.rangeBg, color: product.range.color.rangeText}} className='rounded-xl lg:rounded-3xl px-4 lg:px-8 py-2 lg:py-4 font-bold text-sm lg:text-lg leading-relaxed min-w-max '>
                                    {
                                        Object.keys(product.range.data).map((key, i) => (
                                            <div key={i} className='flex flex-col my-1 lg:my-2'>
                                                <p>{key}</p>
                                                <p>{product.range.data[key]}</p>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        }
                        {
                            product.name === 'Milk Products' &&
                            <div className='flex flex-col m-4 lg:my-8 w-0 lg:ml-16'>
                                <div className='rounded-xl lg:rounded-3xl px-4 lg:px-8 py-2 lg:py-4 font-bold text-sm lg:text-lg leading-relaxed min-w-max' style={{ background: product.range.color.rangeBg, color: product.range.color.rangeText }}>

                                    <div className='flex flex-col'>
                                        <table>
                                            {
                                                Object.keys(product.range.data).map((key, i) => (
                                                    <tr>
                                                        <td><p>{key}</p></td>
                                                        <td className='px-4 lg:px-6 py-1'><p>{product.range.data[key]}</p></td>
                                                    </tr>
                                                ))
                                            }
                                        </table>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            (product.name === 'Bakery') &&
                            <div className='flex flex-row w-0 lg:ml-16 m-2 lg:my-8'>
                                <div className='font-bold text-sm lg:text-lg leading-relaxed min-w-max' >

                                    <div className='rounded-xl lg:rounded-3xl px-4 lg:px-8 py-4 lg:py-4 flex flex-col mx-2  max-w-max' style={{ background: product.range.color.rangeBg, color: product.range.color.rangeText }}>
                                        {
                                            Object.keys(product.range.data.column1).map((key, i) => (
                                                <div className='flex flex-row mb-2 w-auto'>
                                                    <p className=''>{key}</p>
                                                </div>
                                            ))
                                        }
                                    </div>

                                </div>
                                <div className='w-0 font-bold text-sm lg:text-lg leading-relaxed' >
                                    <div className='rounded-xl lg:rounded-3xl px-4 lg:px-8 py-4 lg:py-4 flex flex-col min-w-max' style={{ background: product.range.color.rangeBg, color: product.range.color.rangeText }}>
                                        {
                                            Object.keys(product.range.data.column2).map((key, i) => (
                                                <div className='flex flex-row mb-2'>
                                                    <p>{key}</p>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            (product.name === 'Namkeen') &&
                            <div className='flex flex-row my-8 w-0 m-2 lg:ml-16'>
                                <div className='font-bold text-sm lg:text-lg leading-relaxed min-w-max' >
                                    <div className='rounded-xl lg:rounded-3xl px-4 lg:px-8 py-4 lg:py-6 flex flex-col mx-2' style={{ background: product.range.color.rangeBg, color: product.range.color.rangeText }}>
                                        {
                                            Object.keys(product.range.data.column1).map((key, i) => (
                                                <div className='flex flex-row mb-2'>
                                                    <p className>{key}</p>
                                                    <p>{product.range.data.column1[key]}</p>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div className='font-bold text-sm lg:text-lg leading-relaxed w-0' >
                                    <div className='rounded-xl lg:rounded-3xl px-4 lg:px-8 py-4 lg:py-6 flex flex-col min-w-max' style={{ background: product.range.color.rangeBg, color: product.range.color.rangeText }}>
                                        {
                                            Object.keys(product.range.data.column2).map((key, i) => (
                                                <div className='flex flex-row mb-2'>
                                                    <p>{key}</p>
                                                    <p>{product.range.data.column2[key]}</p>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        }


                    </div>


                </div>
            </section>
        </>
    )
}

export default ProductRangeLayout;